import React, { useState } from "react"
import LayoutModal from "../../organisms/layoutModal/layout-modal"
import WhatsApp from "../../../assets/images/whatsapp-icon.png"
import Box1 from "../../../assets/images/modal-whatsapp/box_1.png"
import Box2 from "../../../assets/images/modal-whatsapp/box_2.png"
import Box3 from "../../../assets/images/modal-whatsapp/box_3.png"
import { useStaticQuery, graphql } from 'gatsby';
import useLocaleMode from '../../../hooks/useLocaleMode';
import useMobileMode from "../../../hooks/useMobileMode"
import "./modal-whatsapp.scss"

const ModalWhatsapp = ({ hiddeAction }) => {

    const { locale } = useLocaleMode();
    const query = useStaticQuery(graphql`
    query WHATSAPP_INFO {
      allContentfulTenaHome {
        nodes {
          numeroDeWhatsApp
          node_locale
          tieneChat
          imagenChatWhatsApp {
            file {
              url
            }
          }
        }
      }
    }`
    );

    const { isMobile } = useMobileMode()
    const whatsappInfo = (query && (query.allContentfulTenaHome.nodes.filter(node => node.node_locale.includes(locale))[0]));
    const [stepModal, setStepModal] = useState(1)

    React.useEffect(() => {
        return () => {
            setStepModal(0)
        }
    }, [])

    React.useEffect(() => {
        if (isMobile) {
            window.open("https://api.whatsapp.com/send?phone=" + whatsappInfo.numeroDeWhatsApp)
            hiddeAction()
        }
    })

    const IconClose = <i className="far fa-times-circle f-modal-whatsapp__step__close-icon" onClick={hiddeAction}></i>
    const IconWhatsApp = (<a
        href={"https://api.whatsapp.com/send?phone=" + whatsappInfo.numeroDeWhatsApp}
        target="_blank"
        className="f-modal-whatsapp__step__button"
    >
        <img src={WhatsApp} alt="icono whatsapp" /> Ir a WhatsApp
    </a>)

    return (
        <LayoutModal onClose={hiddeAction}>
            <div className="f-modal-whatsapp">
                <div className={"f-modal-whatsapp__step f-modal-whatsapp__step1" + (stepModal === 1 ? " f-modal-whatsapp__step--show" : "")}>
                    {IconClose}
                    <figure className="f-modal-whatsapp__step1__icon">
                        <img src={WhatsApp} alt="icono whatsapp" />
                    </figure>
                    <h3 className="f-modal-whatsapp__step__title">¡Te vamos a redirigir a WhatsApp Web!</h3>
                    <p className="f-modal-whatsapp__step__text">
                        Para brindarte una asesoría personalizada,
                        te vamos a redirigir a la aplicación web de WhatsApp,
                        allí podrás resolver todas tus inquietudes.
                    </p>
                    <p
                        onClick={() => setStepModal(2)}
                        className="f-modal-whatsapp__step__text f-modal-whatsapp__step1__next-container"
                    >
                        ¿Tienes dudas de cómo usar WhatsApp Web?
                        <i className="fal fa-chevron-right"></i>
                    </p>
                    {IconWhatsApp}
                </div>
                <div className={"f-modal-whatsapp__step f-modal-whatsapp__step2" + (stepModal === 2 ? " f-modal-whatsapp__step--show" : "")}>
                    {IconClose}

                    <p className="f-modal-whatsapp__step__text f-modal-whatsapp__step2__title">
                        ¿Tienes dudas de cómo usar WhatsApp web?
                    </p>

                    <div className="f-modal-whatsapp__step2__images">
                        <img src={Box1} alt="paso 1" />
                        <img src={Box2} alt="paso 2" />
                        <img src={Box3} alt="paso 3" />
                    </div>

                    <p className="f-modal-whatsapp__step__text">
                        ¡Listo, ahora puedes acceder a nuestra asesoría!
                    </p>

                    {IconWhatsApp}
                </div>
            </div>
        </LayoutModal>
    )
};

export default ModalWhatsapp
